import { render, staticRenderFns } from "./RefundOrders.vue?vue&type=template&id=5792d1f6&scoped=true&"
import script from "./RefundOrders.vue?vue&type=script&lang=js&"
export * from "./RefundOrders.vue?vue&type=script&lang=js&"
import style0 from "./RefundOrders.vue?vue&type=style&index=0&id=5792d1f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5792d1f6",
  null
  
)

export default component.exports